import { alpha, Box, styled } from '@mui/material';

import { theme } from '@/design-system';
import { colors } from '@/shared/design-system/colors';

export const GalleryItemContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
  border: 'none',
  borderRadius: '16px',
  background: colors.background.raised,
  cursor: 'pointer',
  width: '100%',
  textAlign: 'left',
  transition: 'background 120ms ease',
  '&:hover': {
    background: alpha(colors.text.primary, 0.04),
  },
});

export const ActionsCol = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
});

export const ActionRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  width: '100%',
  '& > *': { flex: 1, minWidth: 0 },
});

export const InvestorItemContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr 1fr 1.3fr 294px',
  alignItems: 'center',
  background: '#222833',
  borderRadius: '12px',
  padding: '8px 16px',
  width: '100%',
  gap: '16px',
  minWidth: '1300px',
  cursor: 'pointer',
  ':hover': {
    backgroundColor: theme.colors.background.raised,
  },
});
